export function siteDomain(href: string): string {
  return new URL(href).hostname
    .replace(/^www\./i, "")
    .split(".")
    .slice(-2)
    .join(".");
}
